// extracted by mini-css-extract-plugin
export var emptyState = "_5n-d";
export var statCard = "_5n-c";
export var table = "_5n-0";
export var tableCell = "_5n-4";
export var tableCellClickable = "_5n-5 _5n-4";
export var tableCellDefault = "_5n-6 _5n-4";
export var tableCellEmpty = "_5n-8";
export var tableCellWithValue = "_5n-7";
export var tableContainer = "_5n-e";
export var tableHeaderWeight = "_5n-1";
export var tableHeaderZone = "_5n-2";
export var tableRowHeader = "_5n-3";
export var viewModeButton = "_5n-9";
export var viewModeButtonActive = "_5n-a _5n-9";
export var viewModeButtonInactive = "_5n-b _5n-9";